import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthLayout from "./components/AuthLayout";
import { setAuthFlow, clearAuthFlow } from "./components/authStore";
import { AuthService } from "../../services/auth.service";
import AuthPopup from "./components/AuthPopup";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");

  const [popup, setPopup] = useState({
  open: false,
  type: "error",
  title: "",
  message: "",
  onClose: null,
});

const showPopup = ({ type = "error", title = "Alert", message, onClose = null }) => {
  setPopup({ open: true, type, title, message, onClose });
};

const closePopup = () => {
  const cb = popup.onClose;
  setPopup((p) => ({ ...p, open: false, onClose: null }));
  cb?.();
};

  const inputBase =
    "w-full h-[46px] rounded-[10px] border border-[#f2c6cc] bg-white px-4 text-[14px] text-slate-700 placeholder-slate-400 shadow-[0_12px_26px_rgba(216,106,120,0.14)] outline-none focus:border-[#d86a78] focus:ring-2 focus:ring-[#f7d7db]";

  const buttonBase =
    "w-full h-[46px] rounded-[10px] bg-[#d86a78] text-white font-semibold shadow-[0_12px_26px_rgba(216,106,120,0.22)] hover:bg-[#c95b69] active:scale-[0.99] transition";

  const onSubmit = (e) => {
    e.preventDefault();
    (async () => {
      try {
        clearAuthFlow();
        await AuthService.forgotSendOtp({ email });
        setAuthFlow({ resetEmail: email, otpVerified: false, mode: "forgot" });
        nav("/admin/otp");
      } catch (err) {
        showPopup({
  type: "error",
  title: "OTP Failed",
  message: err?.message || "Unable to send OTP",
});
      }
    })();
  };

  return (
    <AuthLayout>
      <h1 className="mb-4 text-center text-[32px] font-bold tracking-wide text-[#d86a78]">
        ADMIN LOGIN
      </h1>

      <div className="mx-auto w-full max-w-[360px]">
        <p className="mb-5 text-center text-[13px] leading-5 text-slate-500">
          Please enter the email address associated with your account to reset password.
        </p>

        <form onSubmit={onSubmit} className="space-y-6">
          <div className="space-y-2">
            <label className="text-[12px] font-semibold tracking-wider text-slate-500">
              EMAIL
            </label>
            <input
              className={inputBase}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              autoComplete="email"
            />
          </div>

          <button type="submit" className={buttonBase}>
            SUBMIT
          </button>

          <div className="text-center">
            <button
              type="button"
              onClick={() => nav("/admin/login")}
              className="text-xs font-medium text-slate-400 hover:text-[#d86a78]"
            >
              Back to Login
            </button>
          </div>
        </form>
      </div>
      <AuthPopup
  open={popup.open}
  type={popup.type}
  title={popup.title}
  message={popup.message}
  onClose={closePopup}
/>
    </AuthLayout>
  );
}